interface ReleaseSearchIntentInput {
  type?: string;
  format?: string;
  country?: string;
  yearFrom?: number;
  yearTo?: number;
  labels?: readonly string[];
  companies?: readonly string[];
}

/** Whether the active facets express intent to browse physical releases. */
export function hasReleaseSearchIntent(input: ReleaseSearchIntentInput) {
  return Boolean(
    input.type ||
    input.format ||
    input.country ||
    input.yearFrom ||
    input.yearTo ||
    input.labels?.length ||
    input.companies?.length,
  );
}
